export interface CustomerServiceInfo {
  phone: string;
  /** `tel:` link for the phone number. */
  phoneHref: string;
  email: string;
  /** Short form for headers, e.g. `M-F 6AM-5PM PST | S-S 6AM-4PM PST`. */
  hours: string;
  /** Sentence form for body copy, e.g. the receipt footer. */
  hoursLong: string;
}

export const CUSTOMER_SERVICE_INFO: Record<string, CustomerServiceInfo> = {
  // Source of truth: the branded site, drmartypets.com/contact
  default: {
    phone: `(800) 670-1839`,
    phoneHref: `tel:18006701839`,
    email: `support@drmartypets.com`,
    hours: `M-F 6AM-5PM PST | S-S 6AM-4PM PST`,
    hoursLong: `Monday - Friday from 6:00 am to 5:00 pm PST and Saturday - Sunday from 6:00 am to 4:00 pm PST`,
  },
};

/** Resolves the customer-service info for a currency, falling back to the default (USD) entry. */
export function getCustomerServiceInfo(currency: string | undefined | null): CustomerServiceInfo {
  return (currency && CUSTOMER_SERVICE_INFO[currency]) || CUSTOMER_SERVICE_INFO['default'];
}
